// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"ZZ-z","sponsoredTooltipWrapper":"_Z-z","sponsoredTooltip":"a0-z","newCard":"b0-z"};